import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../assets/img/icon/Right.svg';
import { CoverageStatus } from '../../constants/policies.constant';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../query/vehicles/vehicles';
import SuraCard from '../SuraCard';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: `calc(100% - ${theme.spacing(2)}px)`,
      '& a': {
        height: '100%',
      },
      '& button': {
        height: '100%',
      },
      marginTop: '25px',
      // "& div": {
      //   height: "100%",
      // },
    },
  })
);

interface VehicleCardsProps {
  baseUrl?: string;
  setFunction?: (id: any) => void;
  verified?: boolean;
  withPolicy?: boolean;
  showOnAssistance?: boolean;
  policyId?: number;
  plateNumber?: string;
}

const CustomButton: React.FC<VehicleCardsProps> = (props) => {
  const { baseUrl, setFunction, children } = props;
  return setFunction ? (
    <ButtonBase onClick={setFunction} style={{ width: '100%' }}>
      {children}
    </ButtonBase>
  ) : (
    <ButtonBase
      component={Link}
      to={baseUrl || '/dashboard'}
      style={{ width: '100%' }}
    >
      {children}
    </ButtonBase>
  );
};

const VehicleCards: React.FC<VehicleCardsProps> = ({
  baseUrl,
  setFunction,
  verified,
  withPolicy,
  showOnAssistance,
  policyId,
  plateNumber,
}) => {
  const classes = useStyle();
  const { data: vehicles } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const assistanceValidator = (vehicle: any) => {
    return (
      !showOnAssistance ||
      (showOnAssistance && vehicle.assistance_provider?.phone)
    );
  };

  const vehicleToShow = verified
    ? vehicles?.filter(
        (vehicle: any) =>
          vehicle.policy.status === 'active' && assistanceValidator(vehicle)
      )
    : vehicles;

  return (
    <Grid container>
      <CustomButton></CustomButton>
      {vehicleToShow?.map(
        (vehicle: any, index: number) =>
          assistanceValidator(vehicle) && (
            <Grid item xs={12} sm={6} key={index}>
              <Box mx={1} my={1} className={classes.card}>
                <CustomButton
                  setFunction={
                    setFunction ? () => setFunction(vehicle) : undefined
                  }
                  baseUrl={
                    withPolicy
                      ? baseUrl + vehicle.policy.id
                      : baseUrl + vehicle.id
                  }
                >
                  <SuraCard>
                    <Box
                      m={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        flexDirection="column"
                      >
                        <Box textAlign="left">
                          <Typography
                            display="inline"
                            style={{ fontFamily: 'Inter', color: '#000' }}
                          >
                            {vehicle.brand + ' ' + vehicle.model + ' '}{' '}
                          </Typography>
                          <Typography
                            display="inline"
                            variant="caption"
                            style={{ fontFamily: 'Inter', color: '#000' }}
                          >
                            {vehicle.year + '/' + vehicle.license_plate}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant="caption"
                            style={{ fontFamily: 'Inter', color: '#000' }}
                          >
                            Póliza: {vehicle.policy.number} -{' '}
                            {CoverageStatus[vehicle.policy.status]}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <RightIcon></RightIcon>
                      </Box>
                    </Box>
                  </SuraCard>
                </CustomButton>
              </Box>
            </Grid>
          )
      )}
    </Grid>
  );
};

export default VehicleCards;
